import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_Reference } from '../../../../../_entity/reference/ModuleFE_Reference.js';
import { resolveReferenceDisplay } from '../../../../../_entity.js';
import './Renderer_ReferenceHeader.scss';
export class Renderer_ReferenceHeader extends ComponentSync {
    __onReferencesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.reference?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ reference: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.reference?._id)
            state.reference = ModuleFE_Reference.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'reference-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        const ref = this.state.reference;
        const label = ref ? resolveReferenceDisplay(ref) : 'New Reference';
        return _jsx("div", { className: 'reference-header__title', children: label });
    };
    render_Subtitle = () => {
        const ref = this.state.reference;
        if (!ref?.type)
            return;
        return _jsx("span", { className: 'reference-header__sub-title', children: ref.type });
    };
}
//# sourceMappingURL=Renderer_ReferenceHeader.js.map